/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDtoOfSettlementDto } from '../../models/paginated-dto-of-settlement-dto';

export interface GetSettlements$Params {
  name?: string;
  limit?: number;
}

export function getSettlements(http: HttpClient, rootUrl: string, params?: GetSettlements$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDtoOfSettlementDto>> {
  const rb = new RequestBuilder(rootUrl, getSettlements.PATH, 'get');
  if (params) {
    rb.query('name', params.name, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDtoOfSettlementDto>;
    })
  );
}

getSettlements.PATH = '/api/v1/settlements';
